<template>
  <b-container
    fluid
    class="d-flex flex-column mh-100 h-100"
    :style="appLoaded ? colorStyle : null"
  >
    <Spinner v-if="!appLoaded" />
    <SplashScreenModal />
    <FaqModal />
    <SearchModal />

    <template v-if="appLoaded">
      <ShowHideBuilder />

      <b-row class="mh-100 h-100">
        <SideTabs
          class="d-none d-md-block d-xl-none"
          cols="3"
        />
        <b-col
          cols="12"
          md="9"
          xl="12"
          class="d-flex align-items-start flex-column mh-100 vertical-scroll"
        >
          <div class="mb-auto w-100">
            <b-navbar
              sticky
              :style="colorStyle"
              class="px-0 py-3"
            >
              <MobileHeader />
            </b-navbar>
            <MobileCol1 />
            <MobileCol2 />
            <SideBarFade />
          </div>
          <OrbVizLegal class="py-1" />
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import Spinner from '@/components/public/Spinner.vue'
import MobileHeader from '@/components/public/mobile/MobileHeader.vue'
import MobileCol1 from '@/components/public/mobile/MobileCol1.vue'
import MobileCol2 from '@/components/public/mobile/MobileCol2.vue'
import ShowHideBuilder from '@/components/builder/ShowHideBuilder.vue'
import SplashScreenModal from '@/components/public/SplashScreenModal.vue'
import SideTabs from '@/components/public/SideTabs/SideTabs.vue'
import SearchModal from '@/components/public/SearchModal.vue'
import FaqModal from '@/components/public/FaqModal.vue'
import OrbVizLegal from '@/components/admin/OrbVizLegal.vue'
import SideBarFade from '@/components/public/SideBarFade.vue'

const components = {
  Spinner,
  MobileCol1,
  MobileCol2,
  MobileHeader,
  ShowHideBuilder,
  SplashScreenModal,
  SideTabs,
  SearchModal,
  FaqModal,
  OrbVizLegal,
  SideBarFade,
}

@Component({ components })
export default class MobileView extends Vue {
  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }

  get activeTab () {
    return this.$typedStore.public.display.activeTab?.path ?? ''
  }

  get color () {
    return this.$typedStore.primary.entities.nodes.colour(this.activeTab)
  }

  get sidebarBotFontColor () {
    return this.$typedStore.primary.app.config.storySettings.sidebarBot.fontColor
  }

  get colorStyle () {
    return {
      'background-color': this.color,
      color: this.sidebarBotFontColor,
    }
  }
}

</script>
